import { busApi } from 'api/axios'
import { documentBusUrls } from './documentBus.urls'

export const updateODVWebStatus = async ({
  saleOrderId,
  headerStatusId,
  statusName,
}) => {
  const { data } = await busApi.patch(documentBusUrls.updateSaleOrder, {
    saleOrderId,
    headerStatusId,
    statusName,
  })
  return data
}

export const searchSaleOrderId = async ({ saleOrderId }) => {
  const { data } = await busApi.get(
    `${documentBusUrls.searchSaleOrderId}${saleOrderId}`
  )
  return data
}

export const notifyCreateRequest = async ({ documentHeaderId }) => {
  const { data } = await busApi.post(documentBusUrls.notifyCreateRequest, {
    documentHeaderId,
  })
  return data
}

/**
 * Searches for invoices in the system using various filtering parameters.
 *
 * @param {Object} props - Search parameters.
 * @param {string} props.integrationInvoiceId - Integration invoice ID.
 * @param {string} props.customerName - Customer's name.
 * @param {string} props.documentNumber - Document number.
 * @param {string} props.purchaseOrderId - Purchase order ID.
 * @param {string} props.branchOfficeName - Branch office name.
 * @param {number} props.totalAmount - Total invoice amount.
 * @param {string} props.salespersonName - Salesperson's name.
 * @param {string} props.initDate - Start date for filtering in YYYY-MM-DD format.
 * @param {string} props.endDate - End date for filtering in YYYY-MM-DD format.
 * @param {number} props.pageNumber - Page number for pagination.
 * @param {number} props.pageSize - Number of items per page.
 *
 * @returns {Promise<Object>} Response data containing the list of found invoices.
 */
export const searchIntegrationDocuments = async props => {
  const { data } = await busApi.post(
    documentBusUrls.searchIntegrationDocuments,
    {
      ...props,
    }
  )
  return data
}

/**
 * Fetches all branch offices available in the system.
 * @returns {Promise<Object>} Response data containing the list of branch offices.
 */

export const listBranchOffices = async ({ branchID }) => {
  const { data } = await busApi.get(
    `${documentBusUrls.listBranchOffices}${branchID}`
  )
  return data
}

export const searchInoviceDocumentDetail = async integrationInvoceId => {
  const { data } = await busApi.get(
    `${documentBusUrls.detailDocument}${integrationInvoceId}`
  )

  return data
}
